
import { css } from 'lit';
export default css`
@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__container{box-sizing:border-box;position:relative}.splide__list{backface-visibility:hidden;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{align-items:center;display:flex;flex-wrap:wrap;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{backface-visibility:hidden;box-sizing:border-box;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}pc-teaser-card a{
    background-image:linear-gradient(
      transparent calc(100% - 2px),
      var(--primary-eggplant) 2px
    );
    background-repeat:no-repeat;
    background-size:0 100%;
    transition:background-size 0.3s;
    padding:0.25rem 0rem;
    display:inline !important;
  }pc-teaser-card a:focus,
  pc-teaser-card a:hover{
    color:var(--purple-indigo);
  }pc-teaser-card [slot='title'] a::after{
    content:'';
    position:absolute;
    inset:0;
  }pc-teaser-card [slot='image']{
    display:flex;
  }pc-teaser-card [slot='image'] img{
      width:100%;
      height:100%;
      object-fit:cover;
      transition:scale ease-in-out 0.5s;
    }pc-teaser-card [slot='contents'][footer],
pc-teaser-card [slot='title'][footer]{
  color:var(--neutral-charcoal);
  font-family:var(--ff-body);
  font-size:var(--fs-body-mobile);
  font-style:normal;
  font-weight:400;
  line-height:var(--lh-body-mobile);
}@media (min-width: 992px){pc-teaser-card [slot='contents'][footer],
pc-teaser-card [slot='title'][footer]{
    font-size:var(--fs-body);
    line-height:var(--lh-body)
}
  }pc-teaser-card[hovered='hovered'] [slot='image'] img{
    scale:1.1;
  }#splide{
  display:grid;
  row-gap:var(--spacing-8);
}.splide__track{
  grid-column:1 / 3;
}.splide__arrows{
  margin-left:auto;
  margin-right:var(--spacing-12);
}.title{
  color:var(--primary-eggplant);
  font-family:var(--ff-display);
  font-size:var(--fs-h2-mobile);
  font-style:normal;
  font-weight:var(--fw-light);
  line-height:var(--lh-h2);
  grid-column:1 / 3;
  display:flex;
  justify-content:space-between;
}@media (min-width: 780px){.title{
    grid-column:1 / 2;
    display:inline-flex;
    gap:2rem;
    justify-content:flex-start
}
  }.splide__slide img{
  width:100%;
}.splide__arrows .splide__arrow{
  margin-inline:var(--spacing-4);
  padding:12px 32px;
  cursor:pointer;
  border-radius:0px 100px 100px 0px;
  border:2px solid var(--purple-indigo);
  background-image:url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Icon/Arrow/Right'%3E%3Cpath id='Vector 3' d='M0 9.97059H16M16 9.97059L8.75745 1.5M16 9.97059L8.75745 17.5' stroke='%235B39B7' stroke-width='2'/%3E%3C/g%3E%3C/svg%3E");
  background-position:center;
  background-repeat:no-repeat;
  background-color:var(--primary-white);
}.splide__arrows .splide__arrow:hover,
  .splide__arrows .splide__arrow:focus{
    background-color:var(--purple-indigo);
    background-image:url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Icon/Arrow/Right'%3E%3Cpath id='Vector 3' d='M0 9.97059H16M16 9.97059L8.75745 1.5M16 9.97059L8.75745 17.5' stroke='%23fff' stroke-width='2'/%3E%3C/g%3E%3C/svg%3E%0A");
  }.splide__arrows .splide__arrow[disabled]{
  opacity:0.5;
}.splide__arrows .splide__arrow svg{
  display:none;
}.splide__arrow--prev{
  transform:rotate(180deg);
}@media (min-width: 992px){
  .title{
    font-size:var(--fs-h2);
  }
}.splide * a{
    color:inherit;
    text-decoration:none;
  }
`;